import React from "react";
import styles from "../styles/StatusHistory.module.css";
import StatusHistoryThread from "./StatusHistoryThread";
import Loader from "./Loader";
import { useAtom } from "jotai";
import { statusHistoryAtom } from "../store";
import { MdOutlineExpandLess, MdOutlineExpandMore } from "react-icons/md";

const LoadingComponent = () => {
  return (
    <div className={styles.statusLoadingComp}>
      <Loader />
    </div>
  );
};

const StatusHistoryContainer = () => {
  const [loading, ] = React.useState(false);
  const [statusHistory, ] = useAtom(statusHistoryAtom)
  const [ historyOpen, setHistoryOpen ] = React.useState(false)


  return (
    <section id="sh-thread" className="status-history-container">
      <div className="sh-heading-bx" onClick={()=>setHistoryOpen(!historyOpen)}>
        <h3>Status History</h3>
        {historyOpen && <MdOutlineExpandLess size={30} color="#76808b"/>}
        {!historyOpen && <MdOutlineExpandMore size={30} color="#76808b"/>}
      </div>

      {historyOpen && loading && <LoadingComponent />}
      {historyOpen && !loading && <StatusHistoryThread data={statusHistory} />}
    </section>
  );
};

export default StatusHistoryContainer;
